import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
    form: FormGroup;

    email = '';
    errorMessage = '';
    buttonDisabled = false;
    constructor(
        private router: Router,
        private authService: AuthService,
        private fb: FormBuilder,
        private overlayService: OverlayService
    ) {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    ngOnInit(): void {
    }

    onSubmit() {
        this.overlayService.toggle('processing');
        this.errorMessage = '';
        this.email = this.form.value.email;
        this.authService.passwordReset(this.email).subscribe((data) => {
            this.overlayService.toggle('processing');
            localStorage.setItem('confirmationEmail', this.email);
            if (data.data.accountFound) {
                this.router.navigate(['/password', 'reset', 'confirmation']);
            } else {
                this.buttonDisabled = true;
                this.errorMessage = data.data.message;
            }
        });
    }

    backToLogin() {
        this.router.navigate(['/']);
    }
    changeInputValue() {
        this.buttonDisabled = false;
    }
}
